// src/components/ChatBot.js
import React, { useState, useEffect, useRef } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';
import { BRANDING } from '../utils/helpers';

const ChatBot = ({ faqs, onClose }) => {
  const [messages, setMessages] = useState([{ text: "Hola, soy el asistente virtual. ¿En qué puedo ayudarte?", sender: 'bot' }]);
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);
  
  useEffect(() => messagesEndRef.current?.scrollIntoView({ behavior: "smooth" }), [messages]);

  const handleSend = () => {
    if (!input.trim()) return;
    const userMsg = input.toLowerCase();
    setMessages(prev => [...prev, { text: input, sender: 'user' }]);
    setInput('');
    setTimeout(() => {
      let response = "No entendí. Prueba con 'precio', 'ubicación', 'cita'.";
      const foundFaq = (faqs || []).find(f => f.keywords.some(k => userMsg.includes(k)));
      if (foundFaq) response = foundFaq.a;
      else if (userMsg.includes('cita')) response = "Pida su cita en el formulario.";
      else if (userMsg.includes('emergencia')) response = "🚨 Vaya a emergencias del hospital.";
      setMessages(prev => [...prev, { text: response, sender: 'bot' }]);
    }, 600);
  };

  return (
    <div className="fixed bottom-20 right-4 w-80 bg-white shadow-2xl rounded-lg border border-gray-200 flex flex-col h-96 z-50">
      <div className={`${BRANDING.primaryColor} text-white p-3 rounded-t-lg flex justify-between items-center`}><span className="font-bold flex items-center"><MessageCircle size={16} className="mr-2"/> Asistente</span><button onClick={onClose}><X size={16}/></button></div>
      <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-gray-50">{messages.map((m, i) => <div key={i} className={`p-2 rounded-lg text-sm max-w-[85%] ${m.sender === 'user' ? 'bg-blue-100 ml-auto text-blue-900' : 'bg-white border text-gray-700'}`}>{m.text}</div>)}<div ref={messagesEndRef}/></div>
      <div className="p-3 border-t flex gap-2"><input className="flex-1 border rounded px-2 py-1 text-sm" value={input} onChange={e => setInput(e.target.value)} onKeyPress={e => e.key === 'Enter' && handleSend()}/><button onClick={handleSend} className={`${BRANDING.secondaryColor} text-white p-2 rounded`}><Send size={16}/></button></div>
    </div>
  );
};

export default ChatBot;